export default __webpack_public_path__ + "static/media/jumpyShoe.ecedfb5d.png";